import { COUNTRY_SHORTCODES, VehicleType } from '../../constants'

export const TemplateIds = {
  [COUNTRY_SHORTCODES.US]: {
    referral: {
      [VehicleType.Car]: 'tmpl_7d8pqQoJhwLHL1x38nBfpCuu',
      [VehicleType.Scooter]: 'tmpl_7d8pqQoJhwLHL1x38nBfpCuu',
      [VehicleType.Motorcycle]: 'tmpl_7d8pqQoJhwLHL1x38nBfpCuu',
      [VehicleType.Bicycle]: 'tmpl_9pdz4FX6uwqATzxyQPTc1RYP',
      [VehicleType.Walking]: 'tmpl_9pdz4FX6uwqATzxyQPTc1RYP',
      [VehicleType.Other]: 'tmpl_9pdz4FX6uwqATzxyQPTc1RYP',
    },
    'non-referral': {
      [VehicleType.Car]: 'tmpl_kfaFkGugqG9jqh6aAuc21Vwd',
      [VehicleType.Scooter]: 'tmpl_kfaFkGugqG9jqh6aAuc21Vwd',
      [VehicleType.Motorcycle]: 'tmpl_kfaFkGugqG9jqh6aAuc21Vwd',
      [VehicleType.Bicycle]: 'tmpl_dos19dD2bQ9wjrnVjAWRo1Ff',
      [VehicleType.Walking]: 'tmpl_dos19dD2bQ9wjrnVjAWRo1Ff',
      [VehicleType.Other]: 'tmpl_dos19dD2bQ9wjrnVjAWRo1Ff',
    },
  },
  [COUNTRY_SHORTCODES.JP]: {
    citizen: {
      [VehicleType.Bicycle]: 'tmpl_5kiwLqviWuF2bxBBWrCs1CRG',
      [VehicleType.Scooter]: 'tmpl_eyXNaAszKds5xXJ8frpku6F7',
      [VehicleType.Motorcycle]: 'tmpl_gQVX5gND2A1tBZyC4f4NoU3k',
      [VehicleType.Car]: 'tmpl_s7V45JLyD7aMqfW6uCzeDtga',
    },
    'non-citizen': {
      [VehicleType.Bicycle]: 'tmpl_9wEfN7KzdZ6fG2XLWHNUK7tt',
      [VehicleType.Scooter]: 'tmpl_BTid9QkFYWhy5fmWhnYa9Qzt',
      [VehicleType.Motorcycle]: 'tmpl_gkvJqFyA9huDf47NzUhaiwp3',
      [VehicleType.Car]: 'tmpl_yj4kMvPtjRFa82stZFqbaJDx',
    },
  },
}
